"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = constraintCartTotal;

var _comparator = _interopRequireDefault(require("../utils/comparator"));

function constraintCartTotal(ctx, rule, cart, operator, value) {
  return (0, _comparator.default)(cart.total, operator, value);
}